import { Node } from '@tiptap/core';
import { resolveLetterQrDocInsertPos } from './letterQrInsertion.js';

export const LetterQrBlockExtension = Node.create({
  name: 'letterQrBlock',
  group: 'block',
  atom: true,
  selectable: true,
  draggable: false,

  addAttributes() {
    return {
      align: {
        default: 'center',
        parseHTML: (element) => element.getAttribute('data-align') || 'center',
        renderHTML: (attributes) => ({
          'data-align': attributes.align || 'center',
        }),
      },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-letter-qr-block]' }];
  },

  renderHTML({ node, HTMLAttributes }) {
    const align = node.attrs.align || 'center';
    return [
      'div',
      {
        ...HTMLAttributes,
        'data-letter-qr-block': 'true',
        class: 'letter-qr-block',
        style: `text-align: ${align}`,
      },
      '',
    ];
  },

  addCommands() {
    return {
      insertLetterQrBlock:
        () =>
        ({ state, dispatch, tr }) => {
          const { doc, selection } = state;
          let hasQr = false;
          doc.forEach((node) => {
            if (node.type.name === 'letterQrBlock') hasQr = true;
          });
          if (hasQr) return false;

          const insertPos = resolveLetterQrDocInsertPos(selection);
          if (insertPos == null) return false;
          const qrNode = state.schema.nodes.letterQrBlock.create({ align: 'center' });
          if (dispatch) {
            dispatch(tr.insert(insertPos, qrNode).scrollIntoView());
          }
          return true;
        },
      deleteLetterQrBlock:
        () =>
        ({ editor, commands, state }) => {
          if (!editor.isEditable) return false;
          const { selection } = state;
          const node = selection.node;
          if (node?.type?.name === 'letterQrBlock') {
            return commands.deleteSelection();
          }
          return false;
        },
    };
  },
});

export default LetterQrBlockExtension;
